// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // apiUrl: 'http://localhost:9000/api',
  // apiUrl: 'https://feeney3d.com/api',
  apiUrl: 'https://feeney.interiordesigntools.com/api',
  appUrl: 'https://feeney.interiordesigntools.com',
  // addonUrl: 'https://interiors.feeney3d.com',
  addonUrl: 'http://68.183.30.252:3079',
  // addonUrl: 'http://localhost:4200',
  // addonUrl: 'https://feeney-3d-interior.visionexp.io',
  newCmsUrl: 'https://feeney.interiordesigntools.com/api/v1/projects/getOne/Kxx32UHXyx6GfCkkTD8p1',
  newCms3Url: 'https://metaflow3d.visionexp.io/api/v2/projects/7UgoCZucZIxXTbiM1M8cr',
  // newCmsUrl: 'http://68.183.30.252:3030/api/v1/projects/getOne/Kxx32UHXyx6GfCkkTD8p1'
  replicateModel: 'black-forest-labs/flux-kontext-pro',
  // replicateModel: 'black-forest-labs/flux-kontext-max',
  replicateModelVersion: '',
  replicateUpscaleModel: '',
  replicateUpscaleModelVersion: '',
};

// export const environment = {
//   production: true,
//   apiUrl: 'https://feeney3d.com/api',
//   // apiUrl: 'http://localhost:9000/api',
//   appUrl: 'https://feeney3d.com',
//   addonUrl: 'https://interiors.feeney3d.com',
//   newCmsUrl: 'https://feeney.interiordesigntools.com/api/v1/projects/getOne/Kxx32UHXyx6GfCkkTD8p1',
//   newCms3Url: 'https://metaflow3d.visionexp.io/api/v2/projects/7UgoCZucZIxXTbiM1M8cr',
// };





// WEBPACK FOOTER //
// ./src/environments/environment.ts